import React from "react";
import { Route, Switch } from "react-router-dom";

import * as QueriesQL from "queries/workflow";
import WorkflowPublicSchema from "@common/schema/workflow/public";
import * as Section from "@repoflow/components/section";
import { Crumb } from "@repoflow/components/breadcrumb";

import * as ViewRoute from "./view";
import * as EditRoute from "./edit";
import * as RemoveRoute from "./remove";

// The workflow, and the three things you can do to it.
//
// This route is where `workflowId` enters the app, and every query beneath it
// takes that id as a variable.
const LocalProvider = ({
  match: {
    params,
    params: { workflowId },
  },
  children: Children,
}) => {
  const { base: parentBase, basepath: parentBasepath } =
    Section.useSectionContext();

  const base = `${parentBase}/${workflowId}`;
  const basepath = `${parentBasepath}/:workflowId`;

  // Keyed on the entity, which is what the accidental remount used to do.
  //
  // Every screen below seeds its form state ONCE, from the entity this route
  // resolved. Until the render prop above was called rather than rendered,
  // React saw a new component type on every render and remounted the lot —
  // which reset those forms, and happened to be what made moving from one
  // workflowId to another show the new one's values. It no longer remounts
  // for free, so the reset it was providing is asked for here.
  return (
    <Section.Provider
      key={workflowId}
      schema={WorkflowPublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ params }) => (
        <Section.Query
          query={QueriesQL.get}
          variables={params}
          datapath={"workflows.get"}
        >
          {ContentHandler}
        </Section.Query>
      )}
    </LocalProvider>
  );
}

function ContentHandler({ basepath }) {
  return (
    <Switch>
      <Route path={`${basepath}/remove`} component={RemoveRoute.Content} />
      <Route path={`${basepath}/edit`} component={EditRoute.Content} />
      <Route path={`${basepath}`} component={ViewRoute.Content} />
    </Switch>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath, params: { workflowId } }) => (
        <>
          {/* No useCrumbLabel: a workflow's id IS its name, so fetching to
              render what is already in the URL would be a query per navigation
              for no new information. */}
          <Crumb to={`${base}`} label={workflowId} />

          <Switch>
            <Route path={`${basepath}/remove`} component={RemoveRoute.Indice} />
            <Route path={`${basepath}/edit`} component={EditRoute.Indice} />
            <Route path={`${basepath}`} component={ViewRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => (
  <>
    <EditRoute.Sidebar />
    <ViewRoute.Sidebar />
  </>
);
